import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import NotificationTypes from './types.js';
import { useDispatch } from 'react-redux';

const { Notification, FlexPane, Button } = MojitoPresentation.Components;
const { INSUFFICIENT_FUNDS } = MojitoServices.Betslip.types.ERROR_CODE;
const intentActions = MojitoCore.Intents.actions;

// A notification that is not in map will default to error.
const DEFAULT_NOTIFICATION_TYPE = NotificationTypes.TYPE.ERROR;

export default function BetslipNotifications({ errors, mojitoTools: { config, stringResolver } }) {
    const dispatch = useDispatch();
    const showDepositButton = errorCode => {
        return config.showDepositOnInsufficientFunds && errorCode === INSUFFICIENT_FUNDS;
    };

    const getMessageType = errorCode => {
        const map = config.notificationsMap;
        return (map && map[errorCode]) || DEFAULT_NOTIFICATION_TYPE;
    };

    const resolveMessage = (code, message, additionalInformation) => {
        if (message) {
            return message;
        }

        const messageKey = `$BETSLIP_NOTIFICATIONS.MESSAGES.${code}`;
        const customMessage = stringResolver.resolveAndFormatString(
            messageKey,
            additionalInformation
        );

        return (
            customMessage ||
            stringResolver.resolveAndFormatString('$BETSLIP_NOTIFICATIONS.MESSAGES.UNKNOWN', code)
        );
    };

    const renderNotifications = () => {
        return errors
            .map(error => {
                const { code, message, factor, source = {} } = error;
                const messageType = getMessageType(code);
                if (messageType === NotificationTypes.TYPE.IGNORE) {
                    return;
                }
                const style = config[messageType];
                const notificationMessage = resolveMessage(code, message, factor);
                return (
                    <Notification
                        key={`${code}-${source.id}`}
                        config={style}
                        text={notificationMessage}
                        class="ta-BetslipNotification"
                    >
                        {showDepositButton(code) && (
                            <Button
                                onClick={() => onDepositButtonClick(config, dispatch)}
                                config={config.depositButton}
                                class="ta-DepositButton"
                            >
                                {stringResolver.resolveString(
                                    '$BETSLIP_NOTIFICATIONS.DEPOSIT_BUTTON'
                                )}
                            </Button>
                        )}
                    </Notification>
                );
            })
            .filter(Boolean);
    };

    if (errors.length === 0) {
        return null;
    }

    return (
        <FlexPane class={'ta-BetslipNotifications'} config={config.container}>
            {renderNotifications()}
        </FlexPane>
    );
}

const onDepositButtonClick = (config, dispatch) => {
    const { depositIntent } = config;

    if (depositIntent && depositIntent.type) {
        dispatch(intentActions.publishIntent(depositIntent.type, depositIntent.data));
    }
};
